import { ColumnConfig } from '@/components/table/Table';

export const departmentsTableColumns: ColumnConfig[] = [
  { label: 'Departamentos', field: 'name' },
];
